import React from 'react';
import { useCompany } from '../../Store/storeFunctions';
import { AgGridReact } from 'ag-grid-react';
import EmojiPicker, { Emoji } from 'emoji-picker-react';
import Modal from "react-modal";
import { toastPromise } from '../../Helpers/ToastMessage';
import { v4 as uuidv4 } from "uuid";

import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import { initializeApp } from '@firebase/app';
import { getFirestore, getDoc, setDoc, doc } from '@firebase/firestore';
import { EmojiCellRenderer } from '../../Helpers/AgGridCellRenderers';

const app = initializeApp({
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
});
const db = getFirestore(app);

function TagConfiguration(props) {
  const [tags, setTags] = React.useState([]);
  const [create, setCreate] = React.useState(false);
  const [edit, setEdit] = React.useState(false);
  const [focusedTag, setFocusedTag] = React.useState({Icon: '', Description: '', ID: ''});

  const userCompany = useCompany();
  const gridRef = React.useRef();

  React.useEffect(() => {
    fetchTags();
  }, []);

  async function fetchTags() {
    toastPromise(async () => {
        var tagDoc = await getDoc(doc(db, `/BusinessRules/${userCompany.companyData.code}/Tags/0`));
        
        if (tagDoc && tagDoc.exists()) {
          var data = tagDoc.data();

          if (data && data.Tags) {
            setTags(data.Tags);
          }
        }
      },
      true
    );
  }

  function refresh() {
    fetchTags();
  }

  function editTag() {
    var rows = gridRef.current.api.getSelectedRows();

    if (rows && rows.length > 0) {
      setFocusedTag(rows[0]);
      setEdit(true);
    }
  }

  function saveTag() {
    if (!create && !edit)
      return;

    toastPromise(async () => {
        // Do the work here to save to the database.
        var saveData = {
          Tags: [...tags ]
        };

        if (create) {
          saveData.Tags.push({ ...focusedTag, ID: uuidv4() });
        } else { // Edit
          var index = saveData.Tags.findIndex(o => o.ID == focusedTag.ID);

          if (index > -1) {
            saveData.Tags[index] = focusedTag;
          } else {
            saveData.Tags.push({ ...focusedTag, ID: uuidv4() });
          }
        }

        await setDoc(doc(db, `/BusinessRules/${userCompany.companyData.code}/Tags/0`), saveData);
        setTags(saveData.Tags);
        clearCreateNew();
      },
      false,
      "Loading...",
      "Success!",
      "An error occurred."
    );
  }

  function clearCreateNew() {
    setFocusedTag({ Icon: '', Description: '', ID: '' });
    setCreate(false);
    setEdit(false);
  }

  const tagColumnDefs = [
    {
      checkboxSelection: true,
      valueGetter: (params) => params.data.ID,
      resizable: false,
      width: 50,
      sortable: false,
      filter: false
    },
    {
      field: 'Icon',
      resizable: true,
      sortable: true,
      filter: true,
      cellRenderer: EmojiCellRenderer,
      width: 75
    },
    {
      field: 'Description',
      resizable: true,
      sortable: true,
      filter: true,
      width: 400
    }
  ]

  function renderCreateModal() {
    if (!create && !edit) return null;

    return <Modal
      isOpen={true}
      onRequestClose={clearCreateNew}
      contentLabel={`${ create ? "New" : "Edit" } Tag`}
      portalClassName="TagsModal"
    >
      <div className="TagsModalHeader">{ create ? "New" : "Edit" } Tag</div>
      <div className="TagsModalContent" style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
        <div style={{ display: 'flex', flexDirection: 'row' }}>
          <div style={{ width: 50, marginRight: 10, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            Icon
          </div>

          Description
        </div>

        <div style={{ display: 'flex', flexDirection: 'row', marginBottom: 8 }}>
          <div style={{ border: '1px solid #ccc', height: 50, width: 50, marginRight: 10, borderRadius: 10, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <Emoji unified={focusedTag.Icon} />
          </div>

          <input type="text" className="form-control" placeholder="Tag Description..." value={focusedTag.Description} onChange={(e) => setFocusedTag({ ...focusedTag, Description: e.target.value })} />
        </div>
        
        <EmojiPicker
          onEmojiClick={(e) => setFocusedTag({ ...focusedTag, Icon: e.unified })}
          previewConfig={{
            showPreview: false
          }}
          searchPlaceholder='Search Tag Icon'
          width={'100%'}
        />

        <button type="button" className="btn btn-sm btn-primary" style={{ marginTop: 10 }} onClick={saveTag}>Save { create ? "New " : " " }Tag</button>
      </div>
    </Modal>
  }

  return <div>
    <div className="container-fluid" style={{ margin: 8 }}>
      <div className="row" style={{ marginRight: 50, marginLeft: 50 }}>
        <div className='col-lg-7'></div>

        <div className='col-lg-2'>
          <button type="button" className="btn btn-sm btn-primary" onClick={()=>editTag()}>Edit Selected Tag</button>
        </div>

        <div className='col-lg-2'>
          <button type="button" className="btn btn-sm btn-primary" onClick={()=>setCreate(true)}>Create New Tag</button>
        </div>

        <div className='col-lg-1'></div>
      </div>
      
      <div className="row" style={{ marginTop: 10 }}>
        <div className="col-3">
          <img src="../assets/forms icon.png" style={styles.formsicon} width={250}></img>
        </div>

        <div className="col-9">
          <div style={{ height: 200, width: '90%', position: 'relative' }} className="ag-theme-balham">
            <button className="btn btn-info" style={{position: 'absolute', right: 0, top: -45}} onClick={()=>refresh()}><span className="bi-arrow-clockwise"></span></button>
              <AgGridReact
                ref={gridRef}
                rowData={tags}
                columnDefs={tagColumnDefs}
                suppressRowClickSelection={true}
                enableCellTextSelection={true}
                rowHeight={38}
                rowSelection="single">
              </AgGridReact>
          </div>
        </div>
      </div>
    </div>

    { renderCreateModal() }
  </div>;
}

const styles = {
  formsicon: {
    width: '80%'
  }
}

export default TagConfiguration;